import { useLocation } from 'react-router-dom';

export function useQueryString() {
  return new URLSearchParams(useLocation().search);
}

export function useQueryParameters() {
  const params = new URLSearchParams(useLocation().search);
  const newParams = new URLSearchParams();
  for (const [name, value] of params) {
    newParams.append(name.toLowerCase(), value);
  }
  return newParams;
}

export function useQueryStringParameter(parameter: string) {
  return new URLSearchParams(useLocation().search).get(parameter);
}
